<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="myRules", :showMessage="false", :class="formItemClass")
  template(v-if="isSimpleList")
    UploadInput(ref="uploadInput", v-model="fieldModel", :getVm="getVm")
  template(v-else)
    template(v-if="isEdit")
      template(v-if="onlyIcon")
        el-dropdown(v-if="tools.length", @command="handleCommand")
          i.icon-btn.el-icon-upload2
          template(#dropdown)
            el-dropdown-menu
              el-dropdown-item(v-for="{ id, cnName, icon } in tools", :key="id", :icon="icon", :command="id") {{ cnName }}
        i.icon-btn.el-icon-download(v-if="showTemBtn", @click="openTemDialog", title="下载模版")
        i.icon-btn.el-icon-delete(v-if="isEdit", @click="deleteBatch", title="删除选中")
        i.icon-btn.el-icon-folder-checked(v-if="isEdit && useTarget", title="批量设置存放位置", @click="setTargetFolder(checkedFile)")
        i.icon-btn.el-icon-collection-tag(v-if="isEdit && dictType", title="批量分组", @click="batchGroup(checkedFile)")
      template(v-else)
        el-button(v-for="{ id, cnName, icon } in tools", :key="id", :icon="icon", type="text", @click="handleCommand(id)") {{ cnName }}
        el-button(v-if="showTemBtn", type="text", @click="openTemDialog") 下载模版
        el-button(v-if="isEdit", type="text", icon="el-icon-delete", @click="deleteBatch") 删除
        el-button(v-if="isEdit && useTarget", type="text", icon="el-icon-folder-checked", @click="setTargetFolder(checkedFile)") 批量设置存放位置
        el-button(v-if="isEdit && dictType", type="text", icon="el-icon-collection-tag", @click="batchGroup(checkedFile)") 批量设置分组
    FileTable(
      :class="{ useTarget: requiredTarget }",
      ref="fileTable",
      :show-selection="isEdit",
      :file-list="fieldModel || []",
      :preview="preview",
      :download="downloadHandler",
      :delete="isEdit",
      @delete="onFileRemove",
      @updateLight="updateLight"
    )
      el-table-column(v-slot="{ row, $index }", v-if="dictType", width="150px", label="分组")
        .table-cell-edit-block(@click="batchGroup(fieldModel[$index])") {{ row.groupName }}
      template(v-if="isEdit && useTarget", #btns="{ $index, row }")
        el-tooltip(:content="row.targetFolderPath || '未配置'", placement="top")
          i.file-btn.el-icon-folder-checked(@click="setTargetFolder(fieldModel[$index])")
  el-dialog(width="650px", title="下载模版", :visible.sync="template.visible", :close-on-click-modal="false", append-to-body)
    file-list(:file-list="templateList", @download="downloadHandler")
    template(#footer)
      el-button(@click="closeTemDialog") 关闭
</template>
<script>
import UploadInput from "./upload-input/index.vue";
import FileTable from "@/CommonDP/components/FileList/docFileTable.vue";
import FileList from "@/CommonDP/components/FileList/index.vue";
import { openDoc } from "@/CommonDP/components/custom-dialog/index.js";
import { staticMixins } from "@/CommonDP/VForm/utils";
import docService from "@/CommonDP/service/doc-service";
import approveService from "@/CommonDP/service/approve-service.js";
import { VF_UPLOAD_ENUM } from "./utils";
import { getDictListByCode } from "../dict";
import Vue from "vue";
import { downloadFile, downloadUrltoken } from "@/CommonDP/utils";
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
import { uploader } from "@/CommonDP/utils/IUploader/dp";
import { isFunction } from "lodash-es";
export default {
  components: {
    FileList,
    FileTable,
    UploadInput
  },
  mixins: [staticMixins],
  inheritAttrs: false,
  data() {
    return {
      template: { visible: false },
      defaultValue: [] // field组件change之前的值
    };
  },
  computed: {
    templateList() {
      return (this.options.template || []).map((f) => ({ ...f, $url: downloadUrltoken(f.prjId, f.fileId, f.version) }));
    },
    useTarget() {
      return !!this.options.isNeedTargetFolder;
    },
    showPanel() {
      return !!this.options.showPanel;
    },
    requiredTarget() {
      return this.useTarget && !this.options.templateFolderId;
    },
    dictType() {
      return this.options.dictType;
    },
    isSimpleList() {
      return this.options.listStyle === VF_UPLOAD_ENUM.simple;
    },
    onlyIcon() {
      return this.options.btnStyle === VF_UPLOAD_ENUM.icon;
    },

    tools() {
      const {
        options: { selectEntFile, selectPrjFile, upload }
      } = this;
      return [
        { id: VF_UPLOAD_ENUM.knowledge, cnName: "关联知识文档", visible: selectEntFile, icon: "el-icon-plus" },
        { id: VF_UPLOAD_ENUM.prj, cnName: "关联项目文档", visible: selectPrjFile, icon: "el-icon-plus" },
        { id: VF_UPLOAD_ENUM.local, cnName: "本地上传", visible: upload, icon: "el-icon-upload2" }
      ].filter(({ visible }) => visible);
    },
    myRules() {
      return [
        {
          type: "array",
          required: this.options.required,
          message: this.options.requiredHint || "此项为必填项"
        },
        {
          type: "array",
          options: { first: true },
          defaultField: {
            type: "object",
            fields: {
              targetFolderId: {
                required: this.requiredTarget,
                type: "string",
                message: "有文件未设置目标文件夹"
              }
            }
          }
        }
      ];
    },
    showTemBtn() {
      return this.options.template?.length;
    },
    fileType() {
      const fileType = this.field.options.fileType || "";
      const types = fileType
        .split(";")
        .map((str) => str.trim())
        .filter((str) => str);
      return types;
    },
    idSet() {
      const fieldModel = this.fieldModel || [];
      const idSet = new Set();
      for (const { fileId } of fieldModel) idSet.add(fileId);
      return idSet;
    },
    checkedFile() {
      const {
        fieldModel: list = [],
        $refs: { fileTable, uploadInput }
      } = this;
      const idList = [].concat(fileTable?.checkedIds, uploadInput?.checkedIds).filter((t) => t);
      const ids = new Set(idList);
      return list.filter(({ fileId }) => ids.has(fileId));
    }
  },
  methods: {
    openDoc,
    async downloadHandler({ $url, folderId, version }) {
      const flowInstanceId = this.getFlowDetail?.()?.detail?.flowInstanceId;
      const suffix = flowInstanceId ? `&flowInstanceId=${flowInstanceId}` : "";
      await docService.verifyFileIsDelete(folderId, version);
      downloadFile($url + suffix);
    },
    preview(file) {
      const flowInstanceId = this.getFlowDetail?.()?.detail?.flowInstanceId;
      const versionId = file.fileVersion || file.version || 1;
      const { status, fileId, parentId, fileType } = file;
      const data = { status, fileId, versionId, parentId, fileType, flowInstanceId };
      filePreviewV1(data, this.fieldModel);
      // viewFileMethods(file, {
      //   flowInstanceId,
      //   fileType: file.fileType,
      //   fileId: file.fileId,
      //   versionId: file.fileVersion || file.version || 1
      // });
    },
    async updateLight(row, type) {
      let prjId = this.enterpriseId;
      if (row.fileSource === 2) prjId = row.prjId;
      const messageType = type === 1 ? "优先轻量化操作" : "重新轻量化操作";
      await docService.updateLight(prjId, row.fileId, row.version);
      const file = this.fieldModel.find(({ fileId }) => fileId === row.fileId) || {};
      file.status = "4";
      this.$message.success(`${messageType}成功`);
    },
    async batchGroup(row) {
      if (!this.isEdit) return;
      const rows = row ? [].concat(row) : [];
      if (!rows.length) this.throwErr("未选择文件");
      const id0 = rows[0].groupId;
      const id = rows.every(({ groupId }) => groupId === id0) ? id0 : void 0;
      const val = await this.selectDict(id);
      for (const row of rows) {
        Object.assign(row, val);
      }
    },
    async selectDict(value) {
      const { dictType } = this;
      const list = await getDictListByCode(dictType, false);
      const form = Vue.observable({ value });
      const FContent = {
        render() {
          return (
            <ElSelect style="display:block;" vModel={form.value} filterable={true} size="medium" clearable>
              {list.map(({ cnName, dicId }) => (
                <ElOption key={dicId} label={cnName} value={dicId} />
              ))}
            </ElSelect>
          );
        }
      };
      await this.$msgbox({
        title: "选择分组",
        message: <FContent />,
        showCancelButton: true
      });
      const dicItem = list.find((item) => form.value === item.dicId) || { dicId: form.value };
      return { groupId: dicItem.dicId, groupCode: this.dictType, groupName: dicItem.cnName };
    },
    // 设置文件存放位置
    async setTargetFolder(row) {
      if (!this.isEdit) return;
      const { prjId } = this;
      const rows = row ? (Array.isArray(row) ? row : [row]) : [];
      if (!rows.length) this.throwErr("未选择文件");
      // 处理默认选中
      const defaultList = [];
      let folderId = rows[0].targetFolderId;
      // 批量处理时是否id都一致
      const isEvery = rows.every(({ targetFolderId }) => (targetFolderId || "") === (folderId || ""));
      if (isEvery) {
        const templateFolderId = this.options.templateFolderId;
        if (!folderId && templateFolderId) {
          const { data } = await approveService.queryByOldld(templateFolderId, this.prjId);
          folderId = data;
        }
        if (folderId) {
          const { data: resFolder } = await docService.queryFolderDetail(folderId);
          if (resFolder) {
            const reg = /\s\/\s/g;
            defaultList.push({
              folderId: resFolder.folderId,
              folderName: resFolder.folderName,
              fullName: resFolder.absolutPathName.replace(reg, "/"),
              fullIdPath: resFolder.absolutPathId.replace(reg, "/")
            });
          }
        }
      }
      const opt = {
        prjId,
        defaultList,
        multiple: false,
        title: "选择目录",
        isLeaf: (vo) => vo.childFolder === 0,
        filter: (Vo) => Vo.folderId !== "recycle" && Vo.isFolder === 1,
        check: () => true
      };
      const cb = await this.customEvent("onTargetPanel", opt);
      const [folder = {}] = await this.openDoc(opt, rows);
      if (isFunction(cb)) await cb(folder);
      for (const row of rows) {
        this.$set(row, "targetFolderId", folder.folderId);
        this.$set(row, "targetFolderPath", folder.fullName);
      }
      this.$message.success("设置成功");
      this.emitValidate();
    },
    // 直接传递本组件实例,可供方便本组件方法
    getVm() {
      return this;
    },
    async onFileRemove(file) {
      const { fieldModel } = this;
      this.customEvent("onFileRemove", file);
      this.updateValue(fieldModel);
      this.emitValidate();
    },
    deleteBatch() {
      this.$refs.fileTable.deleteBatch();
      this.emitValidate();
    },
    onUploadError(...arg) {
      this.customEvent("onUploadError", ...arg);
    },
    beforeUpload(file) {
      this.filterFile(file.name) || this.throwErr(`文件${file.name}文件不符合要求`);
    },
    beforeUploadList(list) {
      try {
        this.checkFileNum([...this.fieldModel, ...list]);
      } catch (error) {
        list.splice(0, list.length);
      }
    },
    filterFile(name) {
      const { fileType } = this;
      return !fileType.length || new RegExp(`.(${fileType.join("|")})$`, "i").test(name);
    },
    handleCommand(key) {
      switch (key) {
        case VF_UPLOAD_ENUM.local:
          this.uploadFile();
          break;
        case VF_UPLOAD_ENUM.prj:
        case VF_UPLOAD_ENUM.knowledge:
          this.openDocDialog(key);
          break;
      }
    },
    async openDocDialog(type) {
      this.preventDesign();
      const {
        prjId,
        dictType,
        filterFile,
        options: { prjRoot, prjRootModule }
      } = this;
      let prjRootId = prjRoot;
      if (prjRoot && prjRootModule) {
        const { data } = await approveService.queryByOldld(prjRoot, this.prjId);
        prjRootId = data;
      }
      const props = {
        filter: (Vo) => Vo.folderId !== "recycle" && (Vo.isFolder || filterFile(Vo.folderName))
      };
      const dataPlus = {
        fileSource: type,
        targetFolderId: "",
        targetFolderPath: "",
        groupCode: dictType,
        groupId: "",
        groupName: ""
      };
      let rootPath;
      switch (type) {
        case VF_UPLOAD_ENUM.prj:
          this.preventPreview();
          rootPath = "项目";
          props.prjId = prjId;
          dataPlus.prjId = prjId;
          if (prjRootId) {
            props.queryRoot = async () => {
              const params = {
                folderId: prjRootId,
                isRead: 1,
                priviAll: "1",
                noRightClickMenu: true,
                prjId: this.prjId
              };
              const { data } = await docService.queryTree(params);
              return data.map((item) => {
                const { childFolder = 0 } = item;
                return {
                  ...item,
                  leaf: childFolder === 0
                };
              });
            };
          }
          break;
        case VF_UPLOAD_ENUM.knowledge:
          rootPath = "知识";
          dataPlus.prjId = "EnterpriseDoc";
          props.queryRoot = () => this.loadErpriseFolderId("0");
          props.queryFolder = (node) => this.loadErpriseFolderId(node.data.folderId);
          break;
        default:
          return;
      }
      const list = await this.openDoc(props);
      const formatList = list.map(({ fullName, checkInUser, checkInDate, status, size: fileSize, folderId: fileId, folderName: fileName, fileType, fileVersion: version }) => ({
        fileId,
        filePath: [rootPath, ...fullName.split("/")].slice(0, -1).join("/"),
        checkInUser,
        checkInDate,
        fileName,
        fileType,
        status,
        fileSize,
        version,
        uploadType: 2, // 0:右键rvt;1:上传文档;2:关联文档;3:视图
        ...dataPlus
      }));
      this.addToList(formatList);
    },
    async loadErpriseFolderId(folderId) {
      const { enterpriseId } = this;
      const { data } = await docService.queryenterpriseTree({ folderId, enterpriseId, noRightClickMenu: true });
      return data;
    },
    addToList(files) {
      this.customEvent("onAdd", files);
      const [...fieldModel] = this.fieldModel || [];
      for (const file of files) {
        file.ignore !== true && !this.idSet.has(file.fileId) && fieldModel.push(file);
      }
      this.updateValue(fieldModel);
      this.emitValidate();
    },
    fileAdded({ versionIds: version, ...file }) {
      const baseFile = {
        ...file,
        version,
        filePath: "本地上传",
        status: "1",
        fileSource: VF_UPLOAD_ENUM.local,
        uploadType: 2, // 关联文档
        prjId: "EnterpriseDoc",
        // ------------------
        targetFolderId: "",
        targetFolderPath: "",
        groupCode: this.dictType,
        groupId: "",
        groupName: ""
      };
      baseFile.checkInUser ??= file.operUserName;
      baseFile.checkInDate ??= file.createTime;
      this.addToList([baseFile]);
      this.customEvent("onUploadSuccess", baseFile);
    },
    checkFileNum(list) {
      const {
        options: { limit }
      } = this;
      if (limit < list.length) {
        this.throwErr("文件数量不得大于" + limit + "个!");
      }
    },
    async uploadFile() {
      this.preventPreview();
      this.preventDesign();
      const params = await uploader.getHiddenParams({});
      const list = await uploader.open({ params, once: false, multiple: true, onAdd: this.beforeUpload, onListAdd: this.beforeUploadList, showPanel: this.showPanel });
      list.forEach(this.fileAdded);
    },
    openTemDialog() {
      this.preventPreview();
      this.preventDesign();
      this.template.visible = true;
    },
    closeTemDialog() {
      this.template.visible = false;
    },
    // 触发form数据更新
    updateValue(value) {
      this.checkFileNum(value);
      this.fieldModel = value || [];
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
